import { Component, OnInit } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { configuracion } from '../../recursos/config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ficha-editar',
  templateUrl: './ficha-editar.component.html',
  styleUrls: ['./ficha-editar.component.css']
})
export class FichaEditarComponent implements OnInit {

  public nombreBeca: string = ""; public detBeca: string = ""; public indBeca: string = "";
  public vecGrupos = []; public vecAsignacion = []; public vecOpciones = []; public vecOtros = []; public vecGrupoOtros = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private alerti: AlertifyService, private srvInsert: IngresoService,
    private confMensaje: configuracion, private ruta: Router) { }

  ngOnInit() {
    this.verDatosReponde();
    this.verGrupoRespuesta();
    this.verOtrosRespuesta();
  }
  //MOSTRAR LA INFORMACION DE UNA ENCUESTA SELECCIONADA Y RESPONDIDA
  async verDatosReponde() {
    const resEnc = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(15, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEnc.success) {
      this.nombreBeca = resEnc.encuesta[0]['strNombreEnc']
      this.indBeca = resEnc.encuesta[0]['strRecomendacionEnc']
    }
    else
      this.alerti.message('No se encntró información de la encuesta Seleccionada');
  }
  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS DE UNA FICHA RESPONDIDA
  async verGrupoRespuesta() {
    this.cargando.abrir();
    this.vecGrupos = []; this.vecAsignacion = []; this.vecOpciones = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(16, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupos = resGrupo.encuesta;
      this.verRespuesRespuesta();
    }
    else
      this.alerti.error('La encuesta selecciona no dispone de preguntas en ese momento');
    this.cargando.cerrar();
  }
  //MOSTRAR EL LISTADO DE TODAS LAS PREGUNTAS DE UNA FICHA RESPONDIDA
  async verRespuesRespuesta() {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(17, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecAsignacion = resGrupo.encuesta;
      this.verOpcionRespuesta();
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de preguntas en ese momento');
  }
  //MOSTRAR EL LISTADO DE TODAS LAS OPCIONES DE UNA FICHA RESPONDIDA
  async verOpcionRespuesta() {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(18, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecOpciones = resGrupo.encuesta;
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de preguntas en ese momento');
  }
  //MOSTRAR EL LISTADO DE TODAS LAS OPCIONES DE UNA FICHA RESPONDIDA
  async verOtrosRespuesta() {
    this.vecOtros = []; this.vecGrupoOtros = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(24, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupoOtros = resGrupo.encuesta;
    }

    const resOtros = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(23, localStorage.getItem('localVerResp'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resOtros.success) {
      this.vecOtros = resOtros.encuesta;
    }
  }
  imprimirRespuestas() {
    let divToPrint = document.getElementById('divImprime').innerHTML;
    let newWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    newWindow.document.open();
    newWindow.document.write(`
        <html>
        <head>
        <title>Print tab</title>
        <style> </style>
        </head>
        <body onload="window.print();window.close()">${divToPrint}
        </body>
        </html>
        `);
    newWindow.document.close();
  }
  //VER LAS MARCACIONES DE LOS RADIOBUTTON DE LAS OPCIONES
  verMarca(respOp) {
    for (let contH in this.vecOpciones) {
      if ((this.vecOpciones[contH]['intPregunta'] == respOp.intPregunta) && (this.vecOpciones[contH]['intResponde'] == respOp.intResponde))
        this.vecOpciones[contH]['strRespuesta'] = false;

      if ((this.vecOpciones[contH]['intPregunta'] == respOp.intPregunta) && (this.vecOpciones[contH]['intResponde'] == respOp.intResponde)
        && (this.vecOpciones[contH]['intOpcion'] == respOp.intOpcion))
        this.vecOpciones[contH]['strRespuesta'] = true;
    }
  }
  //ENVIAR LAS RESPUESTAS EDITADAS
  async enviarRespEditadas() {
    let banRes = 1;

    for (let objResOp of this.vecOpciones) {
      if (objResOp.intTipo == 3 || objResOp.intTipo == 4) {
        if (objResOp.strRespuesta != '' && objResOp.strRespuesta != null)
          banRes *= 1;
        else
          banRes *= 0;
      }
    }
    if (banRes == 1) {

      this.cargando.abrir();
      for (let objResOp of this.vecOpciones) {
        const resEnc = await new Promise<any>(resolve =>
          this.srvInsert.ingresoFicha(objResOp.intOpcion, objResOp.intResponde, objResOp.strRespuesta, 'na', 'na', 'na', 'na', 'na', 'na', 'na',
            'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 3).subscribe(translated => {
              resolve(translated)
            }));
      }
      for (let objOtro of this.vecOtros) {
        const resEnc = await new Promise<any>(resolve =>
          this.srvInsert.ingresoFicha(objOtro.intIdOtroO, objOtro.intRespuesta, objOtro.strValorResp, 'na', 'na', 'na', 'na', 'na', 'na', 'na',
            'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 4).subscribe(translated => {
              resolve(translated)
            }));
      }
      this.cambiaEstadoResponde(localStorage.getItem('localVerResp'));
      this.cargando.cerrar();
    }
    else
      this.alerti.error('HAY CAMPOS POR COMPLETAR');
  }

  //CAMBIAR EL ESTADO DE UNA RESPUESTA DE FICHA
  cambiaEstadoResponde(numFicha) {
    this.srvInsert.ingresoEncuesta(numFicha, 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 10).subscribe(res => {
      if (res.encuesta) {
        this.alerti.success('Encuesta regitrada con éxito');
        this.enviarCorreo();
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo() {
    let contenido = this.confMensaje.bodyMensaje(1,'na','na', 'na', 'na', 'na') + localStorage.getItem('localNombre') + ' ' + localStorage.getItem('localApellidos') +
      this.confMensaje.bodyMensaje(10,'na','na', 'na', 'na', 'na');

    this.srvInsert.envioMail('Ficha del estudiante: ' + this.nombreBeca, localStorage.getItem('localCorreo'), btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
      else {
        this.vecOpciones = []; this.vecOtros = [];
        localStorage.setItem('localVerResp', '0');
        this.ruta.navigate(["/becario"]);
      }
    });
  }
}
